<template>
  <router-view />
</template>

<script>
export default {
  name: "ReportPage",
  data() {
    return {};
  }
};
</script>

<style scoped>
.report-index.container {
  height: 100%;
}
</style>